export default __webpack_public_path__ + "static/media/varvara.964149ea.jpg";